import { render, staticRenderFns } from "./InstagramOutline.vue?vue&type=template&id=4cdbe056&"
import script from "./InstagramOutline.vue?vue&type=script&lang=ts&"
export * from "./InstagramOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports